import { useTopUp } from '@/features/ai/credits/CreditsDialogContext'
import { MenuButton } from './MenuButton'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  balance: string
  required: string
}

/**
 * Баланса не хватает ещё ДО клика: кнопки перевода погашены, а здесь — выход,
 * пополнение. Отдельная строка «не хватает» не нужна: цена на кнопке и погашенная
 * кнопка говорят это сами.
 */
export const BalanceShortNotice = ({ balance, required }: Props) => {
  const topUp = useTopUp()
  const m = useMessages(messages)
  return (
    <div className="space-y-2">
      <MenuButton variant="default" onSelect={() => topUp.open({ balance, required })}>
        {m.buyCredits}
      </MenuButton>
    </div>
  )
}
